import { TicketedEvent } from '@Types/ticketedEvents';
import { Ticket } from 'lucide-react';

type ResourceType = 'ticketed';

// interface from:
// import { EventContentArg, EventImpl } from '@fullcalendar/core/index.js';
interface EventImpl {
  start: Date | null;
  end: Date | null;
  startStr: string;
  endStr: string;
  id: string;
  groupId: string;
  allDay: boolean;
  title: string;
  url: string;
  display: string;
  startEditable: boolean;
  durationEditable: boolean;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  classNames: string[];
}

interface EventContentArg {
  event: EventImpl;
  timeText: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  isDraggable: boolean;
  isStartResizable: boolean;
  isEndResizable: boolean;
  isMirror: boolean;
  isStart: boolean;
  isEnd: boolean;
  isPast: boolean;
  isFuture: boolean;
  isToday: boolean;
  isSelected: boolean;
  isDragging: boolean;
  isResizing: boolean;
  extendedProps: {
    resourceType: ResourceType;
    aohEvent: TicketedEvent;
  };
}

export function renderEventContent(eventInfo: EventContentArg) {
  return (
    <div className="w-full">
      <p className="line-clamp-3 text-wrap">
        <Ticket
          size={16}
          style={{ marginRight: '4px' }}
          className="inline-block"
        />
        <b>{eventInfo.timeText}</b> <span>{eventInfo.event.title}</span>
      </p>
    </div>
  );
}
